var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRailsBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334.471,
    height: 421.351,
    viewBox: "0 0 334.471 421.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rails-black",
    transform: "translate(-7.254 -8.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer7",
    transform: "translate(26.247 356.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3993",
    d: "M286.594,555.5v72.492h18.489V609.112l16.827,16.827h28.37l-22.5-22.5s16.188-.263,17.412-23.674c0-21.479-16.207-24.262-34.925-24.262Zm19.369,19.663H321.91v12.914H305.963Z",
    transform: "translate(-286.594 -555.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3997",
    d: "M334.79,555.6c-10.124-.059-24.165.88-24.165,19.958v50.384H329.6V613.609h18.392v12.034h19.078V572.814c0-16.57-18.411-17.218-28.272-17.218C337.567,555.6,336.236,555.6,334.79,555.6Zm-4.893,18.2H347.7v19.86H329.9Z",
    transform: "translate(-235.394 -555.301)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4001",
    width: 19.635,
    height: 69.349,
    transform: "translate(150.695 0.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4003",
    d: "M347.571,556.112v69.349h47.253V607.05H366.9V555.805Z",
    transform: "translate(-156.676 -554.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4005",
    d: "M418.789,555.92v18.718H387.183v6.75h13.5c7.053,0,21.786-.307,21.786,21.789s-10.124,23.32-30.683,23.32H366.931v-16.88h28.535c8.59,0,9.066-2.8,9.066-5.234s-4.392-3.572-13.327-3.572-25.5-4.389-25.5-21.573,8.59-23.63,25.774-23.63,27.311.313,27.311.313Z",
    transform: "translate(-118.042 -555.272)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    transform: "translate(7.254 8.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3966",
    d: "M292.687,759.329H455.935s-36.209-82.238-27-157.723S497.666,491.75,531.42,488.069s52.165,17.184,52.165,17.184l7.366-11.048s-48.484-49.1-109.856-43.572-103.717,46.026-130.1,95.123-41.734,83.465-52.165,135.017S292.687,759.329,292.687,759.329Z",
    transform: "translate(-256.482 -430.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3968",
    d: "M284.209,522.675l31.913,2.454L310.6,557.04l-30.069-3.682Z",
    transform: "translate(-280.527 -276.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3970",
    d: "M317.407,524.918,326,500.985l-28.232-11.048-9.2,25.774Z",
    transform: "translate(-263.401 -346.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3972",
    d: "M325.556,497.812l16.57-19.635-21.479-14.116-17.184,19.022Z",
    transform: "translate(-231.659 -401.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3974",
    d: "M324.438,457.635l14.729,17.8,20.252-11.661L344.69,447.2Z",
    transform: "translate(-186.97 -437.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3976",
    d: "M347.375,444.065l3.682,17.8,25.164-.614L373.763,445.3Z",
    transform: "translate(-138.101 -444.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3978",
    d: "M375.042,450.142l-.614,11.045,17.184,9.2,3.682-5.522Z",
    transform: "translate(-80.462 -431.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3980",
    d: "M373.447,465.237v9.2l16.57,1.841v-7.366Z",
    transform: "translate(-82.552 -398.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3982",
    d: "M356.589,470.71l7.977,14.726,11.661-9.2-2.454-9.821Z",
    transform: "translate(-118.469 -396.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3984",
    d: "M357.322,473.863,369.6,492.274,362.23,505.16l-17.8-19.635Z",
    transform: "translate(-144.369 -380.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3986",
    d: "M346.141,490.133l-7.98,15.957,20.866,17.8,4.909-20.255Z",
    transform: "translate(-157.732 -345.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3988",
    d: "M338.8,507.972l-1.227,21.479L363.347,540.5l-1.227-20.255Z",
    transform: "translate(-158.985 -307.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3990",
    d: "M340.317,532.281l6.139,22.1,32.524,1.841-11.661-23.937Z",
    transform: "translate(-153.138 -256.112)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailsBlack);
export default __webpack_public_path__ + "static/media/rails-black.5ec2046aa40141bcda1a5a5f99d1f500.svg";
export { ForwardRef as ReactComponent };